module.exports = __webpack_public_path__ + "img/horizontal_3_7_6005.69a3f847.png";